import { FC } from 'react';

import { OrderInlayItem } from 'order/writingHints/interface/WritingHints';

import { PSmall } from 'shared/components/Typography';
import { nevada } from 'shared/config/Colors';

import { ItemRow } from '../../ItemRow';
import UtilService from '../../../../../../shared/services/util.service';

interface InlayItemsProps {
  inlayItems: OrderInlayItem[];
}

const InlayItems: FC<InlayItemsProps> = ({ inlayItems }) => {
  return (
    <>
      <ItemRow>
        <PSmall bold>#</PSmall>
        <PSmall bold>Inlay - Check Door Style</PSmall>
      </ItemRow>

      {inlayItems.map((inlayItem, index) => (
        <>
          <ItemRow>
            <PSmall color={nevada}>{index + 1}</PSmall>
            <PSmall color={nevada}>
              #{inlayItem.number}, {inlayItem.quantity},{' '}
              {UtilService.generateLineItemNameWithDimensions(inlayItem)}
            </PSmall>
          </ItemRow>

          {inlayItem.orderInlayModifications.map((inlayMod) => {
            if (!inlayMod.isInlay) {
              return null;
            }
            return (
              <ItemRow>
                <PSmall color={nevada}> </PSmall>
                <PSmall color={nevada}>
                  {inlayMod.quantity ?? 1}, {inlayMod.description}
                </PSmall>
              </ItemRow>
            );
          })}
        </>
      ))}
    </>
  );
};

export default InlayItems;
